import { gql } from './gql';
import { ADYEN_ENVIRONMENT, ADYEN_CLIENT_KEY, ADYEN_REVERB_HOLDINGS_CLIENT_KEY } from '@reverbdotcom/env';
import { useQuery } from './useQuery';
import { useExpEnabled } from './user_hooks';
import experiments from './experiments';

export interface AdyenEnvironment {
  clientKey: string;
  environment: string;
}

export const GET_ADYEN_REGION = gql(`
  query Core_GetAdyenRegion {
    getAdyenRegion {
      webRegion
    }
  }
`);

export function useAdyenEnvironment(): AdyenEnvironment {
  const isReverbHoldingsAccountActive = useExpEnabled(experiments.ADYEN_INDEPENDENCE);

  const { data, loading, errors } = useQuery(GET_ADYEN_REGION);
  if (loading) {
    return {
      clientKey: null,
      environment: null,
    };
  } else if (errors) {
    return {
      clientKey: isReverbHoldingsAccountActive ? ADYEN_REVERB_HOLDINGS_CLIENT_KEY : ADYEN_CLIENT_KEY,
      environment: ADYEN_ENVIRONMENT,
    };
  }

  return {
    clientKey: isReverbHoldingsAccountActive ? ADYEN_REVERB_HOLDINGS_CLIENT_KEY : ADYEN_CLIENT_KEY,
    environment: data.getAdyenRegion.webRegion,
  };
}
